import { useEffect, useState } from "react";
import { Container, Row, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FaBoxOpen } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { FiltersProps } from "../../../../@types";
import { CardList } from "../../../../components/card-list";
import { PaginationList } from "../../../../components/pagination";
import { IMaterial } from "../../../../models/IMaterial";
import { removeFavorite } from "../../../../services/favorites.service";
import { listItem } from "../../../../services/item.service";
import handleCardAgroup from "../../../../utils/handleCardAgroup/handleCardAgroup";
import { ListFilters } from "../../components/list-filters";
import { ListContent, NotFound } from "./styles";

export const UnitiesList = (): JSX.Element => {
	const { t: translation } = useTranslation();

	const [hashNews, setHashNews] = useState<IMaterial[][]>([]);
	const [totalItens, setTotalItens] = useState(0);
	const [currentPage, setCurrentPage] = useState(1);
	const [loading, setLoading] = useState<boolean>(false);

	const [filters, setFilters] = useState<FiltersProps>({});

	const queryParams = new URLSearchParams(window.location.search);
	const search = queryParams.get("search");

	useEffect(() => {
		if (hashNews.length) {
			return;
		}

		if (search) {
			setLoading(true);
			return;
		}

		setLoading(true);
		listItem()
			.then((resp) => {
				setTotalItens(resp.count);
				setHashNews(handleCardAgroup(resp.results, 3));
			})
			.catch(() => setLoading(true));
	}, []);

	let history = useHistory();
	const handleUnityDetails = (event?: any) => {
		if (!event.tab) {
			history.push("/unity/" + event.material.id);
		} else {
			window.open("/unity/" + event.material.id);
		}
	};

	const handleFilters = (event?: any) => {
		setFilters({ ...event, page: 1 });
	};

	const handlePageChange = (event?: any) => {
		setFilters({ ...filters, page: event });
	};

	const handleRemoveFavorite = (id: number) => {
		removeFavorite(id)
			.then(() => {
				toast.success("Unidade removida com sucesso!", {
					position: "bottom-center",
				});
			})
			.catch((err: any) => {
				toast.error("Ocorreu um erro ao remover esta unidade.");
			});
	};

	useEffect(() => {
		if (
			Object.keys(filters).length > 0 &&
			(filters.q !== "" ||
				filters.page ||
				(filters.knowledge && filters.knowledge.length !== 0) ||
				(filters.modalities && filters.modalities.length !== 0) ||
				(filters.categories && filters.categories !== ""))
		) {
			setLoading(true);
			listItem(filters)
				.then((resp) => {
					setTotalItens(resp.count);
					setHashNews(handleCardAgroup(resp.results, 3));
					if (filters && filters.page) {
						setCurrentPage(filters.page);
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		}
	}, [filters]);

	return (
		<Container fluid>
			<Row className="mb-2">
				<ListFilters
					hasModalityFilter
					handleFilter={handleFilters}
				></ListFilters>
			</Row>
			<Row>
				<span>
					<b>{totalItens}</b> {translation("filters.resultFound")}
				</span>
			</Row>
			<Row className="mt-4 mb-3">
				{loading ? (
					<NotFound>
						<Spinner
							animation="border"
							variant="primary"
							style={{
								width: "2rem",
								height: "2rem",
								borderWidth: "0.25em",
								borderRightColor: "transparent",
							}}
						/>
					</NotFound>
				) : (
					<>
						{hashNews.length === 0 ? (
							<NotFound>
								<FaBoxOpen className="iconNotFound"></FaBoxOpen>
								<div>Nenhum resultado encontrado</div>
							</NotFound>
						) : (
							<ListContent>
								{!!hashNews.length &&
									hashNews.map(
										(arrayMaterial: IMaterial[], index) => {
											return (
												<div key={index}>
													{arrayMaterial.map(
														(material) => (
															<CardList
																material={
																	material
																}
																onDetails={
																	handleUnityDetails
																}
																removeFavorite={
																	handleRemoveFavorite
																}
															/>
														)
													)}
												</div>
											);
										}
									)}
							</ListContent>
						)}
					</>
				)}
			</Row>
			<Row>
				{!loading && hashNews.length > 0 ? (
					<PaginationList
						currentPage={currentPage}
						totalItems={totalItens}
						onPageChange={handlePageChange}
					></PaginationList>
				) : (
					<></>
				)}
			</Row>
		</Container>
	);
};
